<template>
  <v-row justify="center" v-if="recibo">
    <v-dialog v-model="dialog" scrollable width="auto" :fullscreen="$vuetify.breakpoint.mobile">
      <v-card tile>
        <v-toolbar dark color="primary" dense flat class="max-height">
          <v-spacer></v-spacer>
          <v-toolbar-title class="white--text"> Editar Recibo {{ recibo.numero_recibo }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="py-2">
          <v-data-table class="elevation-5 py-2 my-2" :headers="headers" :items="recibo.detalle" hide-default-footer disable-pagination>
            <template v-slot:top>
              <p class="h4 text-center text-primary">{{ `DETALLE ACTUAL DE RECIBO`.toUpperCase() }}</p>
            </template>
            <template v-slot:[`item.options`]="{ item }">
              <v-icon class="ma-2" color="red" @click="removeItem(item)">mdi-close</v-icon>
            </template>
          </v-data-table>
          <v-data-table v-if="pa_editar.length" class="elevation-5 py-2" :headers="headers" :items="pa_editar" hide-default-footer disable-pagination>
            <template v-slot:top>
              <p class="h4 text-center text-primary">{{ `Nuevo Detalle`.toUpperCase() }}</p>
            </template>
            <!-- <template v-slot:[`item.monto`]="{ item }">
              <v-text-field
                :disabled="false"
                type="number"
                v-model.number="item.monto"
                outlined
                dense
                @change="updateTotal"
                :rules="[rules.required, rules.loanMin]"
                :max="item.saldo"
              ></v-text-field>
            </template> -->
            <template v-slot:footer>
              <v-row justify="center" class="mx-2">
                <v-col md="4" sm="6" xl="12"> <v-text-field v-model="new_total" outlined dense readonly label="TOTAL (BS.)"></v-text-field></v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" rounded small v-if="pa_editar.length" @click="concretarReciboEditable(recibo)">
            <v-icon class="mr-1"> mdi-content-save</v-icon> Guardar Nuevo Recibo
          </v-btn>
          <v-btn color="blue darken-1" outlined rounded small @click="closeDialog"> Cancelar <v-icon> mdi-close</v-icon> </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-divider-item ref="refDivider" @addNewDetails="addNewDetails"></dialog-divider-item>
  </v-row>
</template>

<script>
import xaxios from '@/xaxios';
import { parseUnidadNegocio } from '@/components/Utils.js';
import DialogDividerItem from './DialogDividerItem.vue';
export default {
  components: { DialogDividerItem },
  data() {
    return {
      rules: {
        required: (value) => !!value || 'Se requiere un valor',
        loanMin: (value) => value >= 0 || 'Valor debe ser mayor a 0',
        loanMax: (monto, saldo) => monto <= saldo || 'Monto no puede ser mayor al saldo de ' + saldo,
      },
      fieldRules: [(v) => !!v || 'Campo Obligatorio'],
      api_rest: process.env.VUE_APP_API_REST,
      dialog: false,
      recibo: false,
      number: 1,
      old_total: 0,
      new_total: 0,
      pa_editar: [],
      plan_pagos: [],
      pa_eliminar: [],
      headers: [
        // { text: 'id', value: 'id' },
        { text: 'Concepto', value: 'concepto_name' },
        { text: 'N° Cuota', value: 'numero_cuota' },
        { text: 'Monto', value: 'monto' },
        { text: 'Opciones', value: 'options' },
      ],
    };
  },
  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
    number(val) {
      if (val > 0) {
        this.pa_editar = [];
        for (let i = 0; i < val; i++) {
          this.pa_editar.push(val);
        }
      }
    },
  },
  methods: {
    showThisView(recibo, PlanPagos) {
      this.dialog = true;
      this.recibo = recibo;
      this.plan_pagos = PlanPagos;
      this.old_total = this.recibo.total;
      this.loadConceptosOptionals();
    },
    removeItem(item) {
      this.$refs.refDivider.showThisView(item, this.plan_pagos);
    },
    addNewDetails(nuevos_detalles, current_detalle) {
      this.pa_eliminar.push(current_detalle.id);
      this.recibo.detalle = this.recibo.detalle.filter((detail) => detail.id != current_detalle.id);
      nuevos_detalles.forEach((item) => {
        item.monto = item.monto_calculado;
        this.pa_editar.push(item);
      });
      this.updateTotal();
    },
    updateTotal() {
      this.new_total = 0;
      this.pa_editar.forEach((item) => (this.new_total += +item.monto));
    },
    loadConceptosOptionals() {
      let url = `${this.api_rest}/api/pagos/conceptos/buscar`;
      let datasend = { unidad_negocio_id: parseUnidadNegocio(this.$store.state.CARGO.sede.unidad_negocio) };
      xaxios
        .post(url, datasend)
        .then(({ data }) => {
          data = data.filter((concepto) => concepto.opcional && concepto.estado);
          data = data.map((concepto, i = 0) => ({
            ...concepto,
            index: ++i,
            cuota_id: null,
            concepto_id: concepto.id,
            concepto_pago_id: concepto.id,
            concepto: concepto.nombre,
            saldo: concepto.monto,
            pago: concepto.monto,
            name: `${concepto.id} - ${concepto.nombre} - ${concepto.monto}`,
            numero_cuota: 1,
            optional: true,
          }));
          this.plan_pagos = this.plan_pagos.concat(data);
        })
        .catch(() => this.$root.$notify.show(`No se logró cargar los datos opcionales`, { color: 'primary' }));
    },
    concretarReciboEditable(recibo) {
      const url = `${this.api_rest}/api/pagos/recibo/modificar`;
      let data = {
        recibo_id: recibo.id,
        unidad_negocio_id: recibo.sede_id,
        cuotas: this.pa_editar.map((item) => ({
          cuota_id: item.cuota_id ? item.cuota_id : null,
          concepto: `${item.concepto_name} - ${item.numero_cuota}`,
          monto: item.monto,
          concepto_id: item.concepto_pago_id,
          opcional: item.cuota_id ? false : true,
        })),
      };
      // window.console.log(JSON.stringify({ recibo_id: recibo.id, detalle: this.pa_eliminar }), JSON.stringify(data), url);
      xaxios
        .post(url, { recibo_id: recibo.id, detalle: this.pa_eliminar })
        .then((res) => {
          window.console.log('res de  convertir recibo editable', res);
          if (res.status == 200) {
            xaxios
              .put(url, data)
              .then(() => this.$root.$notify.show(`Recibos Cambiados correctamente`, { color: 'success' }))
              .catch(({ response: { data } }) => this.$root.$notify.show(`${data.error}`, { color: 'danger' }));
            this.closeDialog();
            this.$emit('closeDialog');
          }
        })
        .catch(({ response: { data } }) => this.$root.$notify.show(`${data.error}`, { color: 'danger' }));
      // // // Error, los datos de los items a pagar no pasaron la verificacion
    },

    closeDialog() {
      this.dialog = false;
      this.recibo = null;
      this.old_total = 0;
      this.new_total = 0;
      this.pa_editar = [];
      this.pa_eliminar = [];
      this.plan_pagos = [];
    },
  },
};
</script>
<style scoped>
.w-10 {
  max-width: 10%;
}
.w-20 {
  max-width: 20%;
}
</style>